<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
    <path
      d="M25.12 6H6.88A3.89 3.89 0 0 0 3 9.89v11.22A3.89 3.89 0 0 0 6.88 25h18.24A3.89 3.89 0 0 0 29 21.11V9.89A3.89 3.89 0 0 0 25.12 6Zm0 2h.16L16 14.76 6.72 8h.16ZM27 21.11A1.89 1.89 0 0 1 25.12 23H6.88A1.89 1.89 0 0 1 5 21.11V9.89a1.92 1.92 0 0 1 .1-.59l10.32 7.51a1 1 0 0 0 1.18 0L26.91 9.3a1.92 1.92 0 0 1 .1.59Z"
      data-name="Layer 17"
    />
  </svg>
</template>

<script>
export default {
  name: "EmailIcon",
};
</script>
